import React from 'react';
import PropTypes from 'prop-types';
import Dashed from './Dashed';
import Square from './Square';
import { LEGEND_LABEL_TYPE } from '../../constants';

const Content = ({ item: { color, value, avgRating, type } }) => (
  <>
    {type === LEGEND_LABEL_TYPE.SQUARE ? (
      <Square color={color} />
    ) : (
      <Dashed color={color} />
    )}
    <span className="legend-value">
      <span>{value}</span>
      <b>{avgRating}</b>
    </span>
  </>
);

Content.propTypes = {
  item: PropTypes.object,
  color: PropTypes.string,
  value: PropTypes.string,
  avgRating: PropTypes.string,
  type: PropTypes.string,
};

export default Content;
